import { NgIf } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, ContentChildren, ElementRef, QueryList, computed, input } from '@angular/core';

/* eslint-disable @nx/enforce-module-boundaries */

/* eslint-disable @angular-eslint/component-max-inline-declarations */
import { SwiperComponent } from '@frontend/vanilla/shared/swiper';

@Component({
    selector: 'cs-feature-container',
    standalone: true,
    imports: [SwiperComponent, NgIf],
    templateUrl: './feature-container.component.html',
    styleUrl: './feature-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureContainerComponent implements AfterContentInit {
    private defaultChunkSize = 5;
    private defaultSwipeSize = 5;

    chunkSize = input(this.defaultChunkSize);
    enableNavigation = input(true);
    swipeSize = input(this.defaultSwipeSize);

    swiperOptions = computed(() => ({
        slidesPerView: this.chunkSize(),
        navigation: this.enableNavigation(),
        slidesPerGroup: this.swipeSize(),
    }));

    @ContentChildren('containerContent') contentChildren!: QueryList<ElementRef>;

    ngAfterContentInit(): void {
        this.contentChildren?.forEach((contentItem) => {
            const contentElement = contentItem.nativeElement as HTMLElement;
            if (!contentElement.classList.contains('swiper-slide')) {
                contentElement.classList.add('swiper-slide');
            }
        });
    }
}
